import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { documentPrintModalSelectors } from '@/ModalWindows/DocumentPrintModal/services/selectors';
import { documentPrintModalActions } from '@/ModalWindows/DocumentPrintModal/services/reducer';
import { DocumentTemplateApi } from '@/Api/DocumentTemplates/DocumentTemplatesApi';
import { printService } from '@/Electron';
import { useDocumentPrintModalActions } from '@/ModalWindows/DocumentPrintModal/hooks/useDocumentPrintModalActions';
import { DocumentTemplateRow } from '@/Types';

export function useSingleDocumentPrintModal(onClose: () => void) {
  const dispatch = useDispatch();

  const { printDocuments } = useDocumentPrintModalActions();

  const documentType = useSelector(documentPrintModalSelectors.documentType);
  const selectedTypeNumbers = useSelector(documentPrintModalSelectors.selectedTypeNumbers);
  const selectedNumbersInfo = useSelector(documentPrintModalSelectors.selectedNumbersInfo);

  useEffect(() => {
    dispatch(
      documentPrintModalActions.setSelectedDocumentNumbers([
        {
          documentNumber: selectedTypeNumbers[0].numbers[0],
          countCopy: 1,
        },
      ]),
    );
  }, [selectedTypeNumbers]);

  const onCountCopyChanged = (value: string) => {
    dispatch(
      documentPrintModalActions.setDocumentNumberCountCopy({
        guid: selectedTypeNumbers[0].numbers[0],
        count: Number(value),
      }),
    );
  };

  const onPrint = useCallback(
    async (documentTemplate: DocumentTemplateRow) => {
      if (!documentType) return;

      const printUnionPdfModels = selectedNumbersInfo.map(({ documentNumber, countCopy }) => ({
        orderNumber: documentNumber,
        countCopy: countCopy,
        orderId: selectedTypeNumbers[0].orderId,
      }));

      const document = await DocumentTemplateApi.printUnionPdfFiles({
        printUnionPdfModels,
        numberGenerationType: documentType,
      });

      printService.printDocument(document, documentTemplate.guid);

      onClose();
    },
    [documentType, selectedNumbersInfo, selectedTypeNumbers],
  );

  const onPrintSingleDocument = () => {
    printDocuments(onPrint);
  };

  return {
    onPrintSingleDocument,
    onCountCopyChanged,
  };
}
